/* eslint-disable max-len */
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { selectAppConfig } from 'services/bootup/selectors'
import { selectSite } from 'services/site/selectors'
import {
  selectConsentRegion,
  selectConfirmCountry,
  selectConsentMatrix,
  selectConsentMatrixLoading,
  selectConsentContent,
} from 'services/consents/selectors'
import {
  ContactSupportCopy,
  SectionContent,
  PrivacyWrapper,
  PrivacyLinks,
  MobileFooter,
  WebFooter,
} from '../util'
import CountrySelect from './CountrySelect'
import * as consentActions from 'services/consents/actions'
import * as sharedActions from 'shared/actions'

const mapStateToProps = (state) => ({
  appConfig: selectAppConfig(state),
  site: selectSite(state),
  consentRegion: selectConsentRegion(state),
  consentMatrix: selectConsentMatrix(state),
  matrixLoading: selectConsentMatrixLoading(state),
  confirmCountry: selectConfirmCountry(state),
  consent: selectConsentContent(state),
})

const mapDispatchToActions = {
  ...consentActions,
  changeBulk: sharedActions.changeBulk,
}

function PrivacyCenterContent (props) {
  const {
    appConfig,
    site,
    consentRegion,
    initiateCountryConfirmation,
    matrixLoading,
    cancelCountryConfirmation,
    fetchConsentMatrix,
    confirmCountry,
    updateConsents,
    consentMatrix,
    consent,
    isMobile,
    changeBulk,
  } = props
  const appName = site.name || 'MapMyRun'

  return (
    <PrivacyWrapper>
      <SectionContent>
        <b>
          <FormattedMessage
            id='privacy_center.manage.title'
            defaultMessage="Manage your privacy and data protection usage with Under Armour, Inc. and { appName }."
            values={ { appName } }
          />
        </b>
      </SectionContent>

      { consentRegion ?
        <CountrySelect
          consent={consent}
          consentRegion={consentRegion}
          initiateCountryConfirmation={initiateCountryConfirmation}
          cancelCountryConfirmation={cancelCountryConfirmation}
          confirmCountry={confirmCountry}
          consentMatrix={consentMatrix}
          matrixLoading={matrixLoading}
          updateConsents={updateConsents}
          fetchConsentMatrix={fetchConsentMatrix}
          changeBulk={changeBulk}
        />
        : null }

      <PrivacyLinks
        editConsents={consentRegion !== 'US'}
        exportData={true}
        accountDelete={true}
        contactSupport={!appConfig.isChina}
        logout={true}
        isMobile={isMobile}
        screenName='privacy_center'
      />

      {appConfig.isChina ?
        <SectionContent>
          <ContactSupportCopy />
        </SectionContent>
      : null}

      { isMobile ? <MobileFooter /> : <WebFooter /> }
    </PrivacyWrapper>
  )
}

PrivacyCenterContent.propTypes = {
  appConfig: PropTypes.object,
  site: PropTypes.object,
  location: PropTypes.object,
  consentMatrix: PropTypes.object,
  confirmCountry: PropTypes.string,
  updateConsents: PropTypes.func,
  initiateCountryConfirmation: PropTypes.func,
  cancelCountryConfirmation: PropTypes.func,
  fetchConsentMatrix: PropTypes.func,
  consentRegion: PropTypes.string,
  isMobile: PropTypes.bool,
  matrixLoading: PropTypes.bool,
  consent: PropTypes.object,
  changeBulk: PropTypes.func,
}

export default connect(mapStateToProps, mapDispatchToActions)(PrivacyCenterContent)
